module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURQBS2QBR2kdwTABS2gBS1wBQ1wBQ0wBS2QBQ1wBQ2gBR19ac7NIAAAALdFJOU/8fAJ+AQBDbYDCg/Jpe0gAAAGRJREFUCNdjUIIDBhCh0QRnKjBhMFNDkxSY1ELDgMwChiAFJlUG9iQGRYZyIFOznEEIyISoxWBqCDA2QZkJBQyMMNEC9iCYWqllcG1gu3AzXcAAyFRjgIIkBqXJxmBgqcSA8BAA8psbFbVMW6YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/prow4.png
// module id = LBnD
// module chunks = 1